import API from './Api.js';
import Utils from "./utils.js";




function toggleCerca(){

    $("#overlay_cerca").toggleClass("show");
    $("#red_paral_player").toggleClass("overlay");
    $("#input_ricerca").val("");
    if($(window).innerWidth() > 1100){
        $(".hide_in_search").toggle();
        $("#search_bar").toggle();
    } else{
        $(".hide_in_search").not(".header-nav").not("#red_paral_player").toggle();
        $("#search_bar").toggle();
    }
}
$(document).on({
    click: function () {
        if($("#input_ricerca").val() != ""){
          Utils.showWaitingLoader();
          grecaptcha.execute();
          setTimeout(function () {
              $('#form-captcha').submit();
          }, 2000);
        } else{
          toggleCerca();
        }

    }
}, "#pulsante_cerca");


$(document).on('click', '#go_back_ricerca', function (e) {


    grecaptcha.execute();
    var token  = grecaptcha.getResponse();
    var value = $(this).attr("data-value")
    if(token != "" && typeof token != "undefined" && value != "") {
        $("#input_ricerca").val("");
        // replaceNavigation('/search/' + word_to_search);

        addNavigation('/search', null, {
            method: 'post',
            data:{
                value: value,
                token:token
            }
        });
        toggleCerca();
        grecaptcha.reset();
        grecaptcha.execute();
    }
    console.log(token);
});


$(document).on('submit', '#form-captcha', function (e) {

    e.preventDefault();

    var word_to_search=$("#input_ricerca").val();

    var token  = grecaptcha.getResponse();

    if(token != "" && typeof token != "undefined" && word_to_search != "") {

        // replaceNavigation('/search/' + word_to_search);

        addNavigation('/search', null, {
            method: 'post',
            data:{
                value: word_to_search,
                token:token
            }
        });
        toggleCerca();
        grecaptcha.reset();
        grecaptcha.execute();
    }
    console.log(token);
    // replaceNavigation('/search/' + word_to_search);
});


$("#input_ricerca").on('keyup', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) {

        $("#pulsante_cerca").trigger("click");
    }
});

$(document).on({
    click: function () {
        toggleCerca();
        $("#mobile_ham_menu").removeClass("menu_mobile");
        $(".hamburger_menu").removeClass("is_open");
        $("#input_ricerca").focus();
    }
}, ".search_logo");



$(document).on({
    click: function () {

        var i=$(this).attr("data-i");
        var pathname = window.location.pathname;
        var value=$(this).attr("data-text") || $(this).attr("data-value");
        var type= $(this).attr("data-type");
        if(i == 1){
            addNavigation(pathname+"/"+type+"/"+value+"/"+i, null,{
                method: 'post',
                data:{
                    value: value
                }
            });
        } else{

            if(type=="news"){

                API.get("site/_searchPostPerPage", {page:i, value: value}, (resp) => {
                    var template="";
                    $.each(resp.post, function (index, post) {

                        let tmp = window.templates["risultati_post"];
                        template += tmp.replaceAll("{{slug}}", post.slug)
                            .replaceAll("{{image}}", post.image)
                            .replaceAll("{{title}}", post.title)
                            .replaceAll("{{category}}", post.category)
                            .replaceAll("{{date}}", post.date)
                    });

                    $("#search_carica_altri-risultati_post").append(template);

                    if(resp.post.length < 9){
                        $(".carica_altri_cont").hide();
                    }
                    $(".carica_altri[data-i="+i+"]").attr("data-i", parseInt(i)+1);


                });
            } else if(type=="podcast"){

                API.get("site/_searchPodcastPerPage", {page:i, value: value}, (resp) => {
                    var template="";
                    $.each(resp.podcast, function (index, post) {

                        let tmp = window.templates["single_blocco_podcast_ricerca"];

                        template += tmp.replaceAll("{{slug}}", post.slug)
                            .replaceAll("{{img_src}}", post.img_src)
                            .replaceAll("{{link_url}}", post.link_url)
                            .replaceAll("{{categoria}}", post.categoria)
                            .replaceAll("{{date}}", post.date)
                            .replaceAll("{{ID}}", post.ID)
                            .replaceAll("{{count}}", post.count)
                            .replaceAll("{{post_title}}", post.post_title)
                    });

                    $("#search_carica_altri-single_blocco_podcast_ricerca").append(template);
                    $(".carica_altri[data-i="+i+"]").attr("data-i", parseInt(i)+1);
                });
            }
        }





    }
}, ".carica_altri");

//////player bottom



